import { render, staticRenderFns } from "./karlilik.vue?vue&type=template&id=c9028e68"
import script from "./karlilik.vue?vue&type=script&lang=js"
export * from "./karlilik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports